// extracted by mini-css-extract-plugin
module.exports = {"atom__pill-container":"styles_atom__pill-container__Y0FUS","pill-container__icon":"styles_pill-container__icon__NBjMT"};